<modal-form-container
  [title]="title"
  [showModal]="showModal"
  className="lg:w-[1200px] md:w-[95vw] md:h-fit !my-0"
  contentClass="flex flex-col min-h-0 overflow-hidden"
  (closeModalEvent)="closeModal()"
  [showFooter]="true"
  [rightFooterButtonLabel]="addLabel"
  [rightFooterButtonDisabled]="addDisabled"
  (rightFooterButtonClick)="handleAssignContactToGroup()"
  [footerLoading]="loading"
>
  <div class="asignContent acg">
    <!-- search -->
    <div class="searchInput acg__toolbar">
      <app-search-input
        class="acg__search"
        placeholder="Search contacts by name"
        (valueChange)="updateSearchTerm($event)"
      />
      @if (contactsService.isLoading || contactsService.isFetching) {
      <app-loading-spinner />
      }
      <p class="acg__count" aria-live="polite">
        @if (selectedCheckedContacts.length) {
        {{ selectedCheckedContacts.length }} selected
        } @else {
        None selected
        }
      </p>
    </div>

    <!-- table -->
    <div class="contentContainer acg__table">
      @if (contacts.length > 0) {
      <div class="bk-panel acg__panel">
        <data-table [seamless]="true" [maxHeight]="'400px'" [skeletonColumns]="5">
          <table class="bk-log">
            <thead>
              <tr>
                <th scope="col" class="acg__check">
                  <input
                    type="checkbox"
                    aria-label="Select every contact on this page"
                    [checked]="getIsAllSelected"
                    (change)="toggleSelectAllContacts()"
                  />
                </th>
                <th scope="col">Name</th>
                <th scope="col" class="acg__email">Email</th>
                <th scope="col">Phone number</th>
                <th scope="col" class="acg__gender">Gender</th>
              </tr>
            </thead>
            <tbody>
              @for (contact of contacts; track contact.id) {
              <tr [class.is-selected]="getContactIsSelected(contact)">
                <td class="acg__check">
                  <input
                    type="checkbox"
                    [attr.aria-label]="'Select ' + contact.firstName + ' ' + contact.lastName"
                    [checked]="getContactIsSelected(contact)"
                    (change)="selectContacts(contact)"
                  />
                </td>
                <td class="acg__name">{{ contact.firstName }} {{ contact.lastName }}</td>
                <td class="quiet acg__email">
                  <span class="acg__clip">{{ contact.emailAddress || '—' }}</span>
                </td>
                <td class="quiet">{{ contact.primaryContactNumber || '—' }}</td>
                <td class="quiet acg__gender">{{ contact.gender || '—' }}</td>
              </tr>
              }
            </tbody>
          </table>
        </data-table>
      </div>
      } @else {
      <div class="acg__empty">
        <app-empty-state
          [message]="searchTerm.trim() ? 'No contacts match that name' : 'No contacts yet'"
          [hint]="searchTerm.trim() ? 'Check the spelling or clear the search.' : 'Add contacts first, then come back to pick them.'"
          [icon]="searchTerm.trim() ? 'search' : 'contacts'"
          size="medium"
        />
      </div>
      }
    </div>

    @if (contacts.length > 0) {
    <div class="paginationContainer acg__pages">
      <app-pagination
        [currentPage]="contactsPagination.pageNumber"
        [totalPages]="contactsPagination.totalPages"
        [loading]="contactsService.isLoading || contactsService.isFetching"
        (onNext)="goToNextPage()"
        (onPrev)="goToPreviousPage()"
        (changePage)="updateContactsPage($event)"
      />
    </div>
    }
  </div>
</modal-form-container>
